import React from "react";

const Stat = ({ label, value, color, rotate, testId }) => (
  <div
    className="crayon-card-soft px-5 py-6 text-center"
    style={{ transform: `rotate(${rotate}deg)`, background: color || "#FFFDF6" }}
    data-testid={testId}
  >
    <div className="font-display text-2xl md:text-3xl text-[#1A1A1A]/70">{label}</div>
    <div className="font-display text-4xl md:text-5xl text-[#E8742C] mt-1">{value}</div>
  </div>
);

export const StatStrip = () => {
  return (
    <section className="px-5 md:px-10" data-testid="stat-strip-section">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-5">
        <Stat
          label="Retarded Coin"
          value="$RETARD"
          rotate={-2}
          color="#FFFDF6"
          testId="stat-coin"
        />
        <Stat
          label="Retarded Holders"
          value="??? 🤷"
          rotate={1.5}
          color="#FFF5E5"
          testId="stat-holders"
        />
        <Stat
          label="Retarded Price"
          value="$0.000???"
          rotate={-1}
          color="#FFFDF6"
          testId="stat-price"
        />
        <Stat
          label="Market Cap"
          value="vibes only"
          rotate={2}
          color="#FFF5E5"
          testId="stat-mcap"
        />
      </div>
    </section>
  );
};

export default StatStrip;
